export interface UploadOverallTracker {
  [jobId: string]: UploadBatchTracker;
}

export interface UploadBatchTracker {
  jobProgressTotal?: number;
  totalUploads?: number;
  completedUploads?: number;
}

export interface UploadFileTracker {
  fileName?: string;
  completed?: boolean;
  progress?: number;
}
